
// Loads and executes the file
import('./AppState.js')
  .then(() => {
    // console.log('AppState.js loaded successfully!');
  })
  .catch((err) => {
    alert('AppState Error. Cannot loca the UI');
    console.error(err);
  });
